import { useQuery } from '@tanstack/react-query';

import { useStoresQuery } from '@/features/stores';
import type { SelectMenuOption } from '@/shared/ui';

import { ordersKeys } from '../api/keys';

export function useWarehousesOptions() {
  const storesQuery = useStoresQuery();

  const query = useQuery({
    queryKey: ordersKeys.warehouses(),
    queryFn: () => {
      if (!storesQuery.data) return [];
      return storesQuery.data.items.map(
        (store): SelectMenuOption => ({
          value: store.id,
          label: store.name,
        }),
      );
    },
    enabled: !!storesQuery.data,
    staleTime: 30_000,
  });

  return query;
}
